export const init = () => {
    const $fields = document.querySelectorAll(".c-Checkbox.-js-checkbox:not(.-js-upgraded)")

    for (const $field of $fields) {
        $field.addEventListener("click", function() {
            // Remove error class
            $field.classList.remove("-is-error")
        })

        $field.classList.add("-js-upgraded")
    }
}
